var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaddy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 8.97193C9.38673 6.95454 9.43471 3.80781 11.3939 1.84859C11.7287 1.51385 12.2714 1.51385 12.6061 1.84859C14.5654 3.80783 14.6133 6.9546 12.75 8.97198V9.46709C13.6531 7.98758 15.2826 6.99994 17.1429 6.99994C17.6162 6.99994 18 7.3837 18 7.85708C18 9.72804 17.0009 11.3657 15.5072 12.2655C16.021 12.0933 16.571 11.9999 17.1429 11.9999C17.6162 11.9999 18 12.3837 18 12.8571C18 15.6974 15.6975 17.9999 12.8571 17.9999H12.75V21.9999C12.75 22.4142 12.4142 22.7499 12 22.7499C11.5858 22.7499 11.25 22.4142 11.25 21.9999V17.9999H11.1429C8.30254 17.9999 6 15.6974 6 12.8571C6 12.3837 6.38376 11.9999 6.85714 11.9999C7.42897 11.9999 7.979 12.0933 8.49284 12.2655C6.99908 11.3657 6 9.72804 6 7.85708C6 7.3837 6.38376 6.99994 6.85714 6.99994C8.71735 6.99994 10.3469 7.98758 11.25 9.46709V8.97193ZM11.25 12.9999H11.1429C10.571 12.9999 10.021 12.9066 9.50716 12.7344C10.2184 13.1628 10.8175 13.7586 11.25 14.4671V12.9999ZM12.75 14.4671C13.1825 13.7586 13.7816 13.1628 14.4928 12.7344C13.979 12.9066 13.429 12.9999 12.8571 12.9999H12.75V14.4671Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaddy);
export default __webpack_public_path__ + "static/media/paddy.fd85dece3d823d08a53ad3b58f0986f7.svg";
export { ForwardRef as ReactComponent };